document.addEventListener("DOMContentLoaded", function () {
  console.log("DOM fully loaded - helmet upsell ready");

  // Polyfill for CustomEvent (older Safari support)
  (function () {
    if (typeof window.CustomEvent === "function") return;
    function CustomEvent(event, params) {
      params = params || { bubbles: false, cancelable: false, detail: null };
      var evt = document.createEvent("CustomEvent");
      evt.initCustomEvent(
        event,
        params.bubbles,
        params.cancelable,
        params.detail
      );
      return evt;
    }
    window.CustomEvent = CustomEvent;
  })();

  // Track whether we should suppress the cart drawer
  var suppressCartDrawer = false;
  // Store cart data so we can open the drawer later
  var pendingCartData = null;

  // Find all Add to Cart buttons
  const addToCartButtons = document.querySelectorAll(
    'form[action="/cart/add"] button[type="submit"]'
  );
  console.log("Found Add to Cart buttons:", addToCartButtons.length);

  // Add click event listeners to Add to Cart buttons
  addToCartButtons.forEach(function (button) {
    button.addEventListener("click", function (event) {
      event.preventDefault();
      event.stopPropagation();

      const form = this.closest('form[action="/cart/add"]');
      if (!form) {
        console.error("Could not find parent form for Add to Cart button");
        return;
      }

      let data = {};
      let handle = document.querySelector("[data-product-handle]");
      if (handle) {
        data.handle = handle.getAttribute("data-product-handle");
      }

      const clickedButton = this;
      const hasUpsell = clickedButton.classList.contains("has-upsell");

      // If this product has an upsell, suppress the cart drawer until popup closes
      if (hasUpsell) {
        suppressCartDrawer = true;
      }

      // Add the main product to cart via AJAX first
      const formData = new FormData(form);
      fetch("/cart/add.js", {
        method: "POST",
        body: formData,
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (cartData) {
          console.log("Product added to cart:", cartData);

          // Store cart data for later drawer open
          pendingCartData = cartData;

          // Check for crash product after main product is in the cart
          if (data.handle) {
            checkCartForCrashProduct(data);
          }

          // Trigger theme cart update (updates count, badge, etc.)
          document.dispatchEvent(
            new CustomEvent("theme:cart:init", { bubbles: true })
          );

          if (hasUpsell) {
            // Show popup instead of cart drawer
            showUpsellPopup();
          } else {
            // No upsell — open cart drawer immediately
            openCartDrawer(cartData);
          }
        })
        .catch(function (error) {
          console.error("Error adding product to cart:", error);
          form.submit();
        });
    });
  });

  // =====================================================
  // CART DRAWER
  // =====================================================

  function openCartDrawer(cartData) {
    var data = cartData || pendingCartData;
    var cartDrawer = document.querySelector('[data-drawer="drawer-cart"]');
    if (cartDrawer && data) {
      cartDrawer.dispatchEvent(
        new CustomEvent("theme:drawer:open", {
          bubbles: true,
          detail: { cart: data },
        })
      );
    }
    // Reset
    suppressCartDrawer = false;
    pendingCartData = null;
  }

  // =====================================================
  // CRASH PRODUCT LOGIC
  // =====================================================

  function checkCartForCrashProduct(data) {
    var insuranceMap = {
      hedonist_crash_replacement: 56507125399933,
      epicurist_crash_replacement: 56507139522941,
      heroine_claasic_crash_replacement: 56507146600829,
      heroine_racer_crash_replacement: 56507132576125,
      psilo_explorer_crash_replacement: 57971442418045,
    };

    console.log(data);

    fetch("/products/" + data.handle + ".js")
      .then(function (res) {
        return res.json();
      })
      .then(function (product) {
        var tags = (product.tags || []).map(function (tag) {
          return tag.toLowerCase();
        });
        for (var tag in insuranceMap) {
          if (tags.indexOf(tag) !== -1) {
            var insuranceVariantId = insuranceMap[tag];
            fetch("/cart.js")
              .then(function (res) {
                return res.json();
              })
              .then(function (cart) {
                var exists = cart.items.some(function (item) {
                  return item.id == insuranceVariantId;
                });
                if (!exists) {
                  addCrashProductToCart(insuranceVariantId);
                }
              })
              .catch(function (err) {
                console.error("Error checking cart for insurance:", err);
              });
            break;
          }
        }
      })
      .catch(function (err) {
        console.error("Error fetching product details:", err);
      });
  }

  function addCrashProductToCart(variantId) {
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        quantity: 1,
        id: variantId,
      }),
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        console.log("Crash insurance added to cart:", data);

        // Update theme cart state
        document.dispatchEvent(
          new CustomEvent("theme:cart:init", { bubbles: true })
        );

        // Only open cart drawer if popup is NOT active
        if (!suppressCartDrawer) {
          openCartDrawer(data);
        }
      })
      .catch(function (err) {
        console.error("Error adding insurance:", err);
      });
  }

  // =====================================================
  // UPSELL POPUP
  // =====================================================

  function showUpsellPopup() {
    console.log("showing popup");
    var popupElement = document.getElementById("helmet-upsell-popup");
    if (popupElement) {
      console.log("Found existing popup element, showing it");
      popupElement.style.display = "flex";
      popupElement.style.zIndex = "999999";
      popupElement.style.position = "fixed";
      initializePopup(popupElement);
    } else {
      console.error(
        "Popup element not found. Make sure the section is properly added to your theme."
      );
    }
  }

  function closeUpsellPopup(openDrawerAfter) {
    var popupElement = document.getElementById("helmet-upsell-popup");
    if (popupElement) {
      popupElement.style.display = "none";
    }

    // Now that popup is closed, open the cart drawer
    if (openDrawerAfter !== false) {
      setTimeout(function () {
        openCartDrawer();
      }, 150);
    }
  }

  function initializePopup(popupElement) {
    // Clone and replace to avoid duplicate listeners
    var continueButton = popupElement.querySelector(".continue-checkout");
    if (continueButton) {
      var newContinue = continueButton.cloneNode(true);
      continueButton.parentNode.replaceChild(newContinue, continueButton);
      newContinue.addEventListener("click", function () {
        closeUpsellPopup(true); // Close popup, then open cart drawer
      });
    }

    var dismissButton = popupElement.querySelector(".dismiss-upsell");
    if (dismissButton) {
      var newDismiss = dismissButton.cloneNode(true);
      dismissButton.parentNode.replaceChild(newDismiss, dismissButton);
      newDismiss.addEventListener("click", function () {
        closeUpsellPopup(true); // Close popup, then open cart drawer
      });
    }

    // Click outside popup content to close
    popupElement.addEventListener("click", function (e) {
      if (e.target === popupElement) {
        closeUpsellPopup(true); // Close popup, then open cart drawer
      }
    });

    var productContainers =
      popupElement.querySelectorAll(".upsell-product");
    productContainers.forEach(function (container) {
      initializeProductContainer(container);
    });
  }

  // =====================================================
  // POPUP PRODUCT CONTAINERS
  // =====================================================

  function initializeProductContainer(container) {
    var addButton = container.querySelector(".add-to-cart-upsell");
    if (!addButton) return;

    var newAddButton = addButton.cloneNode(true);
    addButton.parentNode.replaceChild(newAddButton, addButton);

    newAddButton.addEventListener("click", function () {
      var variantId = this.getAttribute("data-variant-id");
      if (variantId) {
        addUpsellToCart(variantId, this);
      }
    });

    initializeColorSwatches(container);
    initializeImageSlider(container);

    var firstSwatch = container.querySelector(".color-swatch");
    if (firstSwatch) {
      firstSwatch.classList.add("selected");
    }
  }

  function initializeColorSwatches(container) {
    var colorSwatches = container.querySelectorAll(".color-swatch");
    colorSwatches.forEach(function (swatch, index) {
      swatch.addEventListener("click", function () {
        container.querySelectorAll(".color-swatch").forEach(function (s) {
          s.classList.remove("selected");
        });
        this.classList.add("selected");
        showSlide(container, index);
      });
    });
  }

  function initializeImageSlider(container) {
    var dots = container.querySelectorAll(".dot");

    dots.forEach(function (dot, index) {
      dot.addEventListener("click", function () {
        showSlide(container, index);
        updateSelectedColorSwatch(container, index);
      });
    });

    addNavigationArrows(container);
    addTouchSupport(container);
  }

  function addNavigationArrows(container) {
    var slides = container.querySelectorAll(".product-image-slide");
    var imageContainer = container.querySelector(
      ".product-image-container"
    );

    if (imageContainer && slides.length > 1) {
      var prevArrow = document.createElement("div");
      prevArrow.className = "slider-arrow prev";
      prevArrow.innerHTML = "&#10094;";

      var nextArrow = document.createElement("div");
      nextArrow.className = "slider-arrow next";
      nextArrow.innerHTML = "&#10095;";

      imageContainer.appendChild(prevArrow);
      imageContainer.appendChild(nextArrow);

      prevArrow.addEventListener("click", function () {
        navigateSlider(container, "prev");
      });

      nextArrow.addEventListener("click", function () {
        navigateSlider(container, "next");
      });
    }
  }

  function updateSelectedColorSwatch(container, imageIndex) {
    var colorSwatches = container.querySelectorAll(
      ".upsell-popup .color-swatch"
    );
    if (colorSwatches.length > imageIndex) {
      colorSwatches.forEach(function (swatch) {
        swatch.classList.remove("selected");
      });
      colorSwatches[imageIndex].classList.add("selected");
    }
  }

  function showSlide(container, index) {
    var slides = container.querySelectorAll(".product-image-slide");
    var dots = container.querySelectorAll(".dot");

    slides.forEach(function (slide) {
      slide.classList.remove("active");
    });

    dots.forEach(function (dot) {
      dot.classList.remove("active");
    });

    if (slides[index]) {
      slides[index].classList.add("active");
    }

    if (dots[index]) {
      dots[index].classList.add("active");
    }
  }

  function navigateSlider(container, direction) {
    var slides = container.querySelectorAll(".product-image-slide");
    var activeSlide = container.querySelector(
      ".product-image-slide.active"
    );

    if (!activeSlide || slides.length <= 1) return;

    var currentIndex = [].indexOf.call(slides, activeSlide);
    var newIndex;

    if (direction === "prev") {
      newIndex = (currentIndex - 1 + slides.length) % slides.length;
    } else {
      newIndex = (currentIndex + 1) % slides.length;
    }

    showSlide(container, newIndex);
    updateSelectedColorSwatch(container, newIndex);
  }

  function addTouchSupport(container) {
    var imageContainer = container.querySelector(
      ".product-image-container"
    );
    if (!imageContainer) return;

    var touchStartX = 0;
    var touchEndX = 0;

    var supportsPassive = false;
    try {
      var opts = Object.defineProperty({}, "passive", {
        get: function () {
          supportsPassive = true;
        },
      });
      window.addEventListener("testPassive", null, opts);
      window.removeEventListener("testPassive", null, opts);
    } catch (e) {}

    var passiveOption = supportsPassive ? { passive: true } : false;

    imageContainer.addEventListener(
      "touchstart",
      function (e) {
        touchStartX = e.changedTouches[0].screenX;
      },
      passiveOption
    );

    imageContainer.addEventListener(
      "touchend",
      function (e) {
        touchEndX = e.changedTouches[0].screenX;
        handleSwipe();
      },
      passiveOption
    );

    function handleSwipe() {
      var threshold = 50;
      if (touchEndX < touchStartX - threshold) {
        navigateSlider(container, "next");
      } else if (touchEndX > touchStartX + threshold) {
        navigateSlider(container, "prev");
      }
    }
  }

  // =====================================================
  // UPSELL ADD TO CART (popup products)
  // =====================================================

  function addUpsellToCart(variantId, button) {
    var originalText = button.textContent;
    button.textContent = "ADDING...";
    button.disabled = true;

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        items: [
          {
            quantity: 1,
            id: variantId,
          },
        ],
      }),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        console.log("Upsell product added to cart:", data);

        // Update theme cart state
        document.dispatchEvent(
          new CustomEvent("theme:cart:init", { bubbles: true })
        );

        if (window.theme && window.theme.cart) {
          document.documentElement.dispatchEvent(
            new CustomEvent("theme:cart:change", {
              bubbles: true,
            })
          );
        }

        button.textContent = "ADDED!";
        setTimeout(function () {
          button.textContent = originalText;
          button.disabled = false;
        }, 2000);
      })
      .catch(function (error) {
        console.error("Error adding upsell product to cart:", error);
        button.textContent = "ERROR";
        setTimeout(function () {
          button.textContent = originalText;
          button.disabled = false;
        }, 2000);
      });
  }

  // Initialize the popup if it's already in the DOM
  var existingPopup = document.getElementById("helmet-upsell-popup");
  if (existingPopup) {
    initializePopup(existingPopup);
  }
});
